/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Queries from 'fierry/flux/queries';

import ParentEnum from 'astro/enum/parent';


export default class extends Queries
{
  getCurrentGalaxy ()
  {
    return this.getSessionRpc().get('currentGalaxy');
  }


  getCurrentUser ()
  {
    return this.getUsersRpc().get('currentUser');
  }


  getPlanets ()
  {
    let planets = [];

    for (const planet of this.getSessionRpc().get('planets').values())
    {
      planets.push(planet.state.get('currentPlanet'));
    }

    return planets;
  }



  getUser (id)
  {
    return this.getOne(this.getUsersRpc().get('users'), user => user.id === id);
  }


  getUsers ()
  {
    return this.getAll(this.getUsersRpc().get('users'), () => true);
  }


  getUsersRpc ()
  {
    return this.getSessionRpc().get('users');
  }


  getPlanetRpc (id)
  {
    return this.getSessionRpc().get('planets').get(id).state;
  }


  getSessionRpc ()
  {
    return this.props;
  }


};
